import BokioLogo from "@bokio/components/BokioLogo/BokioLogo";
import CompanyList from "@bokio/components/CompanyList/CompanyList";
import { useTopLevelUser } from "@bokio/contexts/TopLevelUserContext/useTopLevelUser";
import { Button } from "@bokio/designsystem/components/Button";
import { Link } from "@bokio/elements/Link/Link";
import { GeneralLangFactory } from "@bokio/lang";
import { useFeatureAvailability } from "@bokio/mobile-web-shared/core/contexts/FeatureAvailabilityContext/FeatureAvailabilityContext";
import * as m from "@bokio/mobile-web-shared/core/model/model";
import { useRouter } from "@bokio/shared/containers/router/useRouter";
import { getRoute } from "@bokio/shared/route";
import { useUser } from "@bokio/shared/state/requests";

import type { FC } from "react";

import * as styles from "./selectCompany.scss";

import CompanyDraftSource = m.Entities.CompanyDraftSource;

export interface SelectCompanyProps {
	currentOrganisationId?: string;
	onChange?: () => void;
}

export const SelectCompany: FC<SelectCompanyProps> = ({ onChange, currentOrganisationId }) => {
	const { redirect } = useRouter();
	const { user } = useUser();
	const { memberships, isLoadingMemberships, signOut } = useTopLevelUser();
	const { AllowNewSignups } = useFeatureAvailability();

	const openCreate = () => {
		memberships && memberships.partners.length > 0
			? redirect(
					getRoute("preCreateClient", { step: "choose-type", source: "select-company" }, { agencyId: undefined }),
				)
			: redirect(
					getRoute("createCompany", { id: undefined, step: undefined }, { source: CompanyDraftSource.ExistingUser }),
				);
	};

	const generalLang = GeneralLangFactory();

	return (
		<div className={styles.selectCompany}>
			<div className={styles.logo}>
				<BokioLogo inverted={false} />
			</div>
			<div className={styles.content}>
				<div className={styles.companyListBox}>
					<div className={styles.title}>{generalLang.CompanyChoose_Heading}:</div>
					<CompanyList currentOrganisationId={currentOrganisationId} onChange={onChange} />
					{!isLoadingMemberships && AllowNewSignups && (
						<Button appearance="primary" testId="SelectCompany_CreateCompany_Btn" onClick={openCreate} margin={["top"]}>
							{generalLang.CreateCompany}
						</Button>
					)}
				</div>
				{signOut && !isLoadingMemberships && (
					<div className={styles.logOutBox}>
						{user && (
							<div className={styles.user}>
								<p className={styles.userName}>
									{user.FirstName ? `${user.FirstName} ${user.LastName}` : generalLang.MyAccount}
								</p>
								<em className={styles.userEmail} data-testid="SelectCompanyEmail">
									{user.Email}
								</em>
								{memberships && memberships.companies.length === 0 && (
									<Link route={getRoute("deleteUserAccount")}>{generalLang.DeleteAccount}</Link>
								)}
							</div>
						)}
						<Button appearance="secondary" onClick={signOut}>
							{generalLang.LogOut}
						</Button>
					</div>
				)}
			</div>
		</div>
	);
};
